/**
 * Canonical list of fonts available in the app.
 * Used by font pickers, TinyMCE editors, and class style helpers.
 *
 * - name: display label
 * - style: CSS font-family value stored/applied in editors
 * - googleFontFamily: Google Fonts family name (omit for system fonts)
 */

export const APP_FONTS = [
  { name: "Acme", style: "acme", googleFontFamily: "Acme" },
  { name: "Advent Pro", style: "advent pro", googleFontFamily: "Advent Pro" },
  { name: "Aladin", style: "aladin", googleFontFamily: "Aladin" },
  { name: "Alata", style: "alata", googleFontFamily: "Alata" },
  { name: "Alan Sans", style: "alan sans", googleFontFamily: "Alan Sans" },
  { name: "Alegreya", style: "alegreya", googleFontFamily: "Alegreya" },
  { name: "Alegreya Sans SC", style: "alegreya sans sc", googleFontFamily: "Alegreya Sans SC" },
  { name: "Alice", style: "alice", googleFontFamily: "Alice" },
  { name: "Alumni Sans SC", style: "alumni sans sc", googleFontFamily: "Alumni Sans SC" },
  { name: "Amatic SC", style: "amatic sc", googleFontFamily: "Amatic SC" },
  { name: "Andika", style: "andika", googleFontFamily: "Andika" },
  { name: "Andale Mono", style: "andale mono,times" },
  { name: "Architects Daughter", style: "architects daughter", googleFontFamily: "Architects Daughter" },
  { name: "Arial", style: "arial,helvetica,sans-serif" },
  { name: "Arial Black", style: "arial black,avant garde" },
  { name: "Audiowide", style: "audiowide", googleFontFamily: "Audiowide" },
  { name: "Bad Scripts", style: "bad scripts", googleFontFamily: "Bad Script" },
  { name: "Bangers", style: "bangers", googleFontFamily: "Bangers" },
  { name: "Belanosima", style: "belanosima", googleFontFamily: "Belanosima" },
  { name: "Belleza", style: "belleza", googleFontFamily: "Belleza" },
  { name: "Berkshire Swash", style: "berkshire swash", googleFontFamily: "Berkshire Swash" },
  { name: "Big Shoulders", style: "big shoulders", googleFontFamily: "Big Shoulders" },
  { name: "Big Shoulders Inline", style: "big shoulders inline", googleFontFamily: "Big Shoulders Inline" },
  { name: "Bona Nova SC", style: "bona nova sc", googleFontFamily: "Bona Nova SC" },
  { name: "Borel", style: "borel", googleFontFamily: "Borel" },
  { name: "Bubblegum Sans", style: "bubblegum sans", googleFontFamily: "Bubblegum Sans" },
  { name: "Bubbler One", style: "bubbler one", googleFontFamily: "Bubbler One" },
  { name: "Booga", style: "boogaloo", googleFontFamily: "Boogaloo" },
  { name: "Book Antiqua", style: "book antiqua,palatino" },
  { name: "Bowlby One SC", style: "bowlby one sc", googleFontFamily: "Bowlby One SC" },
  { name: "Bungee", style: "bungee", googleFontFamily: "Bungee" },
  { name: "Bungee Shade", style: "bungee shade", googleFontFamily: "Bungee Shade" },
  { name: "Cabin Sketch", style: "cabin sketch", googleFontFamily: "Cabin Sketch" },
  { name: "Carter One", style: "carter one", googleFontFamily: "Carter One" },
  { name: "Catamaran", style: "catamaran", googleFontFamily: "Catamaran" },
  { name: "Caveat", style: "caveat", googleFontFamily: "Caveat" },
  { name: "Changa One", style: "changa one", googleFontFamily: "Changa One" },
  { name: "Chewy", style: "chewy", googleFontFamily: "Chewy" },
  { name: "Cinzel", style: "cinzel", googleFontFamily: "Cinzel" },
  { name: "Cal Sans", style: "cal sans", googleFontFamily: "Cal Sans" },
  { name: "Candal", style: "candal", googleFontFamily: "Candal" },
  { name: "Cherry Bomb One", style: "cherry bomb one", googleFontFamily: "Cherry Bomb One" },
  { name: "Coda", style: "coda", googleFontFamily: "Coda" },
  { name: "Comfortaa", style: "comfortaa", googleFontFamily: "Comfortaa" },
  { name: "Comic Relief", style: "comic relief", googleFontFamily: "Comic Relief" },
  { name: "Cormorant", style: "cormorant", googleFontFamily: "Cormorant" },
  { name: "Comic Sans MS", style: "comic sans ms,sans-serif" },
  { name: "Coming Soon", style: "coming soon", googleFontFamily: "Coming Soon" },
  { name: "Concert One", style: "concert one", googleFontFamily: "Concert One" },
  { name: "Cookie", style: "cookie", googleFontFamily: "Cookie" },
  { name: "Corben", style: "corben", googleFontFamily: "Corben" },
  { name: "Delius", style: "delius", googleFontFamily: "Delius" },
  { name: "Dongle", style: "dongle", googleFontFamily: "Dongle" },
  { name: "Courier New", style: "courier new,courier" },
  { name: "Creepster", style: "creepster", googleFontFamily: "Creepster" },
  { name: "Dancing Script", style: "dancing script", googleFontFamily: "Dancing Script" },
  { name: "Electrolize", style: "electrolize", googleFontFamily: "Electrolize" },
  { name: "Faculty Glyphic", style: "faculty glyphic", googleFontFamily: "Faculty Glyphic" },
  { name: "Fjalla One", style: "fjalla one", googleFontFamily: "Fjalla One" },
  { name: "Fredericka the Great", style: "fredericka the great", googleFontFamily: "Fredericka the Great" },
  { name: "Freeman", style: "freeman", googleFontFamily: "Freeman" },
  { name: "Gayathri", style: "gayathri", googleFontFamily: "Gayathri" },
  { name: "Georgia", style: "georgia,palatino" },
  { name: "Gotu", style: "gotu", googleFontFamily: "Gotu" },
  { name: "Graduate", style: "graduate", googleFontFamily: "Graduate" },
  { name: "Great Vibes", style: "great vibes", googleFontFamily: "Great Vibes" },
  { name: "Gruppo", style: "gruppo", googleFontFamily: "Gruppo" },
  { name: "Helvetica", style: "helvetica" },
  { name: "Henny Penny", style: "henny penny", googleFontFamily: "Henny Penny" },
  { name: "Holtwood One SC", style: "holtwood one sc", googleFontFamily: "Holtwood One SC" },
  { name: "IM Fell English SC", style: "im fell english sc", googleFontFamily: "IM Fell English SC" },
  { name: "Impact", style: "impact,chicago" },
  { name: "Indie Flower", style: "indie flower", googleFontFamily: "Indie Flower" },
  { name: "Irish Grover", style: "irish grover", googleFontFamily: "Irish Grover" },
  { name: "Jua", style: "jua", googleFontFamily: "Jua" },
  { name: "Julius Sans One", style: "julius sans one", googleFontFamily: "Julius Sans One" },
  { name: "Just Another Hand", style: "just another hand", googleFontFamily: "Just Another Hand" },
  { name: "Kanit", style: "kanit", googleFontFamily: "Kanit" },
  { name: "Kaushan Script", style: "kaushan script", googleFontFamily: "Kaushan Script" },
  { name: "Klee One", style: "klee one", googleFontFamily: "Klee One" },
  { name: "Knewave", style: "knewave", googleFontFamily: "Knewave" },
  { name: "Lato Black", style: "lato", googleFontFamily: "Lato" },
  { name: "Lemon", style: "lemon", googleFontFamily: "Lemon" },
  { name: "Lexend", style: "lexend", googleFontFamily: "Lexend" },
  { name: "Lilita One", style: "lilita one", googleFontFamily: "Lilita One" },
  { name: "Lobster", style: "lobster", googleFontFamily: "Lobster" },
  { name: "Lobster Two", style: "lobster two", googleFontFamily: "Lobster Two" },
  { name: "Luckiest Guy", style: "luckiest guy", googleFontFamily: "Luckiest Guy" },
  { name: "Macondo", style: "macondo", googleFontFamily: "Macondo" },
  { name: "Marcellus SC", style: "marcellus sc", googleFontFamily: "Marcellus SC" },
  { name: "Marvel", style: "marvel", googleFontFamily: "Marvel" },
  { name: "Mate SC", style: "mate sc", googleFontFamily: "Mate SC" },
  { name: "Merienda", style: "merienda", googleFontFamily: "Merienda" },
  { name: "Merriweather", style: "merriweather", googleFontFamily: "Merriweather" },
  { name: "Michroma", style: "michroma", googleFontFamily: "Michroma" },
  { name: "Momo Trust Display", style: "momo trust display", googleFontFamily: "Momo Trust Display" },
  { name: "Modak", style: "modak", googleFontFamily: "Modak" },
  { name: "Monoton", style: "monoton", googleFontFamily: "Monoton" },
  { name: "Nanum Pen Script", style: "nanum pen script", googleFontFamily: "Nanum Pen Script" },
  { name: "National Park", style: "national park", googleFontFamily: "National Park" },
  { name: "Newsreader", style: "newsreader", googleFontFamily: "Newsreader" },
  { name: "Nunito", style: "nunito", googleFontFamily: "Nunito" },
  { name: "Old Standard TT", style: "old standard tt", googleFontFamily: "Old Standard TT" },
  { name: "Oregano", style: "oregano", googleFontFamily: "Oregano" },
  { name: "Orbitron", style: "orbitron", googleFontFamily: "Orbitron" },
  { name: "Overlock", style: "overlock", googleFontFamily: "Overlock" },
  { name: "Pacifico", style: "pacifico", googleFontFamily: "Pacifico" },
  { name: "Patua One", style: "patua one", googleFontFamily: "Patua One" },
  { name: "Patrick Hand", style: "patrick hand", googleFontFamily: "Patrick Hand" },
  { name: "Permanent Marker", style: "permanent marker", googleFontFamily: "Permanent Marker" },
  { name: "Playwrite US Modern", style: "playwrite us modern", googleFontFamily: "Playwrite US Modern" },
  { name: "Poiret One", style: "poiret one", googleFontFamily: "Poiret One" },
  { name: "Pompiere", style: "pompiere", googleFontFamily: "Pompiere" },
  { name: "Poppins", style: "poppins", googleFontFamily: "Poppins" },
  { name: "Press Start 2P", style: "press start 2p", googleFontFamily: "Press Start 2P" },
  { name: "Protest Guerrilla", style: "protest guerrilla", googleFontFamily: "Protest Guerrilla" },
  { name: "Protest Revolution", style: "protest revolution", googleFontFamily: "Protest Revolution" },
  { name: "Protest Riot", style: "protest riot", googleFontFamily: "Protest Riot" },
  { name: "Protest Strike", style: "protest strike", googleFontFamily: "Protest Strike" },
  { name: "Quando", style: "quando", googleFontFamily: "Quando" },
  { name: "Questrial", style: "questrial", googleFontFamily: "Questrial" },
  { name: "Raleway", style: "raleway", googleFontFamily: "Raleway" },
  { name: "Ranchers", style: "ranchers", googleFontFamily: "Ranchers" },
  { name: "Rancho", style: "rancho", googleFontFamily: "Rancho" },
  { name: "Righteous", style: "righteous", googleFontFamily: "Righteous" },
  { name: "Roboto", style: "roboto", googleFontFamily: "Roboto" },
  { name: "Rock Salt", style: "rock salt", googleFontFamily: "Rock Salt" },
  { name: "Rowdies", style: "rowdies", googleFontFamily: "Rowdies" },
  { name: "Rubik Doodle Shadow", style: "rubik doodle shadow", googleFontFamily: "Rubik Doodle Shadow" },
  { name: "Rubik Moonrocks", style: "rubik moonrocks", googleFontFamily: "Rubik Moonrocks" },
  { name: "Rye", style: "rye", googleFontFamily: "Rye" },
  { name: "Sacramento", style: "sacramento", googleFontFamily: "Sacramento" },
  { name: "Salsa", style: "salsa", googleFontFamily: "Salsa" },
  { name: "Satisfy", style: "satisfy", googleFontFamily: "Satisfy" },
  { name: "Secular One", style: "secular one", googleFontFamily: "Secular One" },
  { name: "Shadows Into Light", style: "shadows into light", googleFontFamily: "Shadows Into Light" },
  { name: "Sniglet", style: "sniglet", googleFontFamily: "Sniglet" },
  { name: "Sour Gummy", style: "sour gummy", googleFontFamily: "Sour Gummy" },
  { name: "Story Script", style: "story script", googleFontFamily: "Story Script" },
  { name: "Sunflower", style: "sunflower", googleFontFamily: "Sunflower" },
  { name: "Single Day", style: "single day", googleFontFamily: "Single Day" },
  { name: "Symbol", style: "symbol" },
  { name: "Tahoma", style: "tahoma,arial,helvetica,sans-serif" },
  { name: "Terminal", style: "terminal,monaco" },
  { name: "Times New Roman", style: "times new roman,times" },
  { name: "Thasadith", style: "thasadith", googleFontFamily: "Thasadith" },
  { name: "Titan One", style: "titan one", googleFontFamily: "Titan One" },
  { name: "Trebuchet MS", style: "trebuchet ms,geneva" },
  { name: "Ultra", style: "ultra", googleFontFamily: "Ultra" },
  { name: "Unbounded", style: "unbounded", googleFontFamily: "Unbounded" },
  { name: "Verdana", style: "verdana,geneva" },
  { name: "Voltaire", style: "voltaire", googleFontFamily: "Voltaire" },
  { name: "Yellowtail", style: "yellowtail", googleFontFamily: "Yellowtail" },
  { name: "Zain", style: "zain", googleFontFamily: "Zain" },
  { name: "Yesteryear", style: "yesteryear", googleFontFamily: "Yesteryear" },
];

export const getGoogleFontsSpecimenUrl = (googleFontFamily) => {
  const family = String(googleFontFamily || "").trim();
  if (!family) {
    return null;
  }

  return `https://fonts.google.com/specimen/${family.replace(/ /g, "+")}`;
};

export const getAppFontPreviewCssFamily = (font) => {
  if (font?.googleFontFamily) {
    return `"${font.googleFontFamily}"`;
  }

  return font?.style || "inherit";
};

export const APP_FONT_PICKER_OPTIONS = APP_FONTS.map(({ name, style }) => ({ name, style }));

export const TINYMCE_FONT_FAMILY_FORMATS = APP_FONTS
  .map((font) => `${font.name}=${font.style}`)
  .join('; ');

const GOOGLE_FONTS_CHUNK_SIZE = 40;

/** Loaded in public/index.html — skip when lazy-loading picker fonts. */
export const CORE_GOOGLE_FONT_FAMILIES = ["Montserrat", "Roboto", "Quicksand", "Lato"];

const CORE_GOOGLE_FONTS_LINK_ID = "ll-core-google-fonts";
const CORE_GOOGLE_FONTS_CACHE_BUST = "ll=20260814";

/** Cache-busted so a print-deferred copy of this CSS cannot stay stuck unloaded. */
export const CORE_GOOGLE_FONTS_STYLESHEET_HREF =
  "https://fonts.googleapis.com/css2?family=Montserrat:wght@200;400;700&family=Lato:wght@900&family=Roboto:wght@400;500&family=Quicksand:wght@400;500;600;700&family=Barlow:wght@400;500;600;700;800&display=swap&" +
  CORE_GOOGLE_FONTS_CACHE_BUST;

export const buildGoogleFontsCss2Urls = ({
  chunkSize = GOOGLE_FONTS_CHUNK_SIZE,
  excludeFamilies = [],
} = {}) => {
  const excluded = new Set(excludeFamilies);
  const families = [...new Set(
    APP_FONTS
      .map((font) => font.googleFontFamily)
      .filter(Boolean)
      .filter((family) => !excluded.has(family))
  )];
  const urls = [];
  for (let index = 0; index < families.length; index += chunkSize) {
    const chunk = families.slice(index, index + chunkSize);
    const query = chunk.map((family) => `family=${family.replace(/ /g, "+")}`).join("&");
    urls.push(`https://fonts.googleapis.com/css2?${query}&display=swap`);
  }
  return urls;
};

let appGoogleFontsLoadPromise = null;

/** Lazy-load Google Fonts for class-style / editor pickers (not needed on public pages). */
const normalizeCssFontPrimaryFamily = (cssFontFamily) =>
  String(cssFontFamily || "")
    .split(",")[0]
    .trim()
    .replace(/^['"]|['"]$/g, "");

export const resolveAppFontByCssFamily = (cssFontFamily) => {
  const normalized = String(cssFontFamily || "").trim().toLowerCase();
  const primaryFamily = normalizeCssFontPrimaryFamily(cssFontFamily).toLowerCase();

  return APP_FONTS.find((font) => {
    if (font.style.toLowerCase() === normalized) {
      return true;
    }

    if (font.name.toLowerCase() === primaryFamily) {
      return true;
    }

    if (font.googleFontFamily?.toLowerCase() === primaryFamily) {
      return true;
    }

    return false;
  });
};

const loadCssFontFace = (cssFontFamily) => {
  if (typeof document === "undefined" || !document.fonts) {
    return Promise.resolve();
  }

  const primaryFamily = normalizeCssFontPrimaryFamily(cssFontFamily) || "Helvetica";
  return document.fonts.load(`16px "${primaryFamily}"`).catch(() => {});
};

export const activatePrintDeferredStylesheets = (root = typeof document === "undefined" ? null : document) => {
  if (!root?.querySelectorAll) {
    return 0;
  }

  const links = root.querySelectorAll('link[rel="stylesheet"][media="print"]');
  links.forEach((link) => {
    link.media = "all";
  });
  return links.length;
};

/** Recover core UI fonts if the HTML stylesheet is missing, print-stuck, or served from a stale cache. */
export const ensureCoreUiFontsLoaded = () => {
  if (typeof document === "undefined") {
    return Promise.resolve();
  }

  activatePrintDeferredStylesheets(document);

  const existingLinks = [...document.querySelectorAll('link[rel="stylesheet"]')];
  const cacheBustedLink = existingLinks.find((link) =>
    String(link.getAttribute("href") || link.href || "").includes(CORE_GOOGLE_FONTS_CACHE_BUST)
  );

  if (cacheBustedLink) {
    if (cacheBustedLink.media === "print") {
      cacheBustedLink.media = "all";
    }
    return loadCssFontFace("Montserrat");
  }

  return new Promise((resolve) => {
    const link = document.createElement("link");
    link.id = document.getElementById(CORE_GOOGLE_FONTS_LINK_ID)
      ? `${CORE_GOOGLE_FONTS_LINK_ID}-reload`
      : CORE_GOOGLE_FONTS_LINK_ID;
    link.rel = "stylesheet";
    link.href = CORE_GOOGLE_FONTS_STYLESHEET_HREF;
    link.onload = () => {
      loadCssFontFace("Montserrat").then(resolve);
    };
    link.onerror = () => {
      resolve();
    };
    document.head.appendChild(link);
  });
};

/** Load a single picker / class-style font so canvas and DOM measurements match. */
export const ensureCssFontFamilyLoaded = (cssFontFamily) => {
  if (typeof document === "undefined") {
    return Promise.resolve();
  }

  const appFont = resolveAppFontByCssFamily(cssFontFamily);
  if (!appFont?.googleFontFamily) {
    return loadCssFontFace(cssFontFamily);
  }

  const linkId = `app-google-font-${appFont.googleFontFamily.replace(/\s+/g, "-").toLowerCase()}`;
  const existingLink = document.getElementById(linkId);

  if (existingLink) {
    return loadCssFontFace(cssFontFamily);
  }

  return new Promise((resolve) => {
    const link = document.createElement("link");
    link.id = linkId;
    link.rel = "stylesheet";
    link.href = `https://fonts.googleapis.com/css2?family=${appFont.googleFontFamily.replace(/ /g, "+")}&display=swap`;
    link.onload = () => {
      loadCssFontFace(cssFontFamily).then(resolve);
    };
    link.onerror = () => {
      resolve();
    };
    document.head.appendChild(link);
  });
};

export const ensureAppGoogleFontsLoaded = () => {
  if (typeof document === "undefined") {
    return Promise.resolve();
  }
  ensureCoreUiFontsLoaded();
  if (appGoogleFontsLoadPromise) {
    return appGoogleFontsLoadPromise;
  }

  const urls = buildGoogleFontsCss2Urls({ excludeFamilies: CORE_GOOGLE_FONT_FAMILIES });
  if (urls.length === 0) {
    appGoogleFontsLoadPromise = Promise.resolve();
    return appGoogleFontsLoadPromise;
  }

  appGoogleFontsLoadPromise = new Promise((resolve) => {
    let pending = urls.length;

    const finish = () => {
      pending -= 1;
      if (pending <= 0) {
        resolve();
      }
    };

    urls.forEach((url, index) => {
      const linkId = `app-google-fonts-${index}`;
      if (document.getElementById(linkId)) {
        finish();
        return;
      }

      const link = document.createElement("link");
      link.id = linkId;
      link.rel = "stylesheet";
      link.href = url;
      link.onload = finish;
      link.onerror = finish;
      document.head.appendChild(link);
    });
  });

  return appGoogleFontsLoadPromise;
};

export const getTinyMceContentStyleWithFonts = () =>
  buildGoogleFontsCss2Urls()
    .map((url) => `@import url('${url}');`)
    .join(" ");
